export enum Routes {
    CHECK = '/',
    INFO_FORM = '/information/form',
    INFO_SUMMARY = '/information/summary',
    INFO_LOOKUP = '/information/lookup',
    SIGN = '/sign',
    SUCCESS = '/success',
    OVERVIEW = '/overview',
    REVIEW_FORM = '/review/form',
    REVIEW_SUMMARY = '/review/summary',
}

export const AUTH_REQUIRED_ROUTES: string[] = [Routes.REVIEW_FORM, Routes.REVIEW_SUMMARY]
